module.exports = __webpack_public_path__ + "img/EID MUBARAK.d1e2dae.svg";